export default __webpack_public_path__ + "static/1572-14cf189a099a7d0bc4094990965a1fcc.gif";